import { Box, Typography } from '@mui/material';

import FooterBar from '@/assets/report-footer-wave.png';

import useStyles from './PDFTemplate.styles';
import type { PDFFooterProps } from './PDFTemplate.types';

const PDFFooter = ({ pageNumber }: PDFFooterProps) => {
  const { classes } = useStyles();

  return (
    <>
      <Box className={classes.footerImageWrapper}>
        <img
          src={FooterBar}
          alt="Footer Design"
          className={classes.footerImage}
        />
      </Box>
      <Box className={classes.pageNumber}>
        <Typography variant="body2" className={classes.pageNumberText}>
          {pageNumber}
        </Typography>
      </Box>
    </>
  );
};

export default PDFFooter;
